import { ELegalVisibility } from 'constants/LegalVisibility';
import { IAccountResponse } from 'models/account';

export const hasAccessToLE = (
  account: IAccountResponse,
  legalUniqueId: string,
  visibilityUniqueId?: string | null,
  prefixGroupUniqueId?: string | null,
  organisationCategoryUniqueId?: string | null,
): boolean =>
  (!visibilityUniqueId ||
    visibilityUniqueId === ELegalVisibility.PUBLIC ||
    account.assignedLegalIds.includes(legalUniqueId)) &&
  (!prefixGroupUniqueId || account.prefixGroupIds.includes(prefixGroupUniqueId)) &&
  (!organisationCategoryUniqueId ||
    account.organisationCategoryIds.includes(organisationCategoryUniqueId));

export const hasAccessToLENoVisibilityCheck = (
  account: IAccountResponse,
  prefixGroupUniqueId?: string | null,
  organisationCategoryUniqueId?: string | null,
): boolean =>
  (!prefixGroupUniqueId || account.prefixGroupIds.includes(prefixGroupUniqueId)) &&
  (!organisationCategoryUniqueId ||
    account.organisationCategoryIds.includes(organisationCategoryUniqueId));
